import React from 'react';

import useDefaultModal from './default-modal.controller';

const ID = 'default-modal';
export interface DefaultModalProps {
    id?: string;
    handleClose: () => void;
    handleClickOutside?: (event: { target: any }) => void;
    show: boolean;
    zIndex?: number;
    children?: React.ReactNode;
    type?: ModalType;
    customWidth?: number;
    className?: string;
    modalRef?: (el: HTMLDivElement | null) => void;
}

export const DefaultModal = (props: DefaultModalProps) => {
    const viewProps = useDefaultModal(props);
    const shouldUseSquareCorners = props.className?.includes('modal-without-radius') || props.className?.includes('wizard-modal-pane');

    if (!props.show) {
        return <></>;
    }

    const modalClassName = () => {
        let className = '';
        if (props.type) {
            className = `modal-${props.type}`;
        } else {
            className = 'modal-default';
        }

        if (props.customWidth) {
            className += ` w-${props.customWidth}/100`;
        }

        if (props.className) {
            className += ` ${props.className}`;
        } else {
            className += ' w-45/100';
        }

        return className;
    };

    return (
        <div
            className='modal-backdrop'
            data-dialog-backdrop='modal'
            data-dialog-backdrop-close='true'
            id={ID + '-' + props.id}>
            <div
                data-dialog='modal'
                onClick={(e) => e.stopPropagation()}
                className={modalClassName() + (shouldUseSquareCorners ? ' bg-white' : ' rounded-2xl bg-white')}
                aria-modal='true'
                style={viewProps.width}
                ref={viewProps.modalRef}>
                {props.children}
            </div>
        </div>
    );
};

export enum ModalType {
    PROMPT = 'prompt',
    PANE = 'pane',
    MOBILE_BOTTOM = 'mobile-bottom',
    BOTTOM = 'bottom'
}
